import { GlobalPageLoadExperience } from '@atlassian/ufo';
import { createRoot } from 'react-dom/client';

import { getRootAppElement } from './elements.ts';

/**
 * Returns the React Root for mounting the application.
 *
 * ```
 * const root = getRoot();
 *
 * root.render(<App />);
 * ```
 */
function getRoot() {
  const rootEl = getRootAppElement();

  return createRoot(rootEl);
}

export function mountAppWithMetrics(mount: (rootGetter: typeof getRoot) => void) {
  GlobalPageLoadExperience.mark('mount-app-start');

  mount(getRoot);

  GlobalPageLoadExperience.mark('mount-app-end');
}
